import React, { useState, useEffect } from 'react';
import FallingFlowers from './FallingFlowers';

const HeroBanner = () => {
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(prev => !prev); // đảo trạng thái fade
    }, 3000); // mỗi 3s đổi trạng thái
    return () => clearInterval(interval);
  }, []);

  const scrollToAISection = () => {
    const element = document.getElementById('ai-app-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-[650px] py-20 md:py-32 bg-gradient-to-r from-primary-100 via-primary-50 to-primary-50 overflow-hidden">
      <FallingFlowers />
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">

        {/* Logo fade in/out liên tục */}
        <div
          className={`p-4 max-w-4xl mx-auto mb-10 text-sm transition-opacity duration-[3000ms] ${fade ? 'opacity-100' : 'opacity-0'
            }`}
        >
          <p className="text-gray-600 text-center flex justify-center items-center">
            <strong className="inline-flex items-center">
              <img
                src="/pics/logo-vanila-web.png"
                alt="Vanilla Logo"
                className="w-[200px] h-[150px] mr-1"
              />
            </strong>
          </p>
        </div>

        <h1 className="text-4xl md:text-6xl font-extrabold text-primary-600 mb-6 leading-tight drop-shadow-lg">
          Chạm Tới Vẻ Đẹp Hoàn Hảo
        </h1>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6">
          Bằng những công nghệ thẩm mỹ tiên tiến và phác đồ cá nhân hoá tinh chỉnh đến từng chi tiết, Vanilla mang đến trải nghiệm làm đẹp an toàn, thông minh và đầy tính nghệ thuật.
        </p>

        <button
          onClick={scrollToAISection}
          className="inline-block px-10 py-4 bg-primary-600 text-white text-lg font-semibold rounded-full hover:bg-primary-700 transition-all shadow-primary-lg transform hover:scale-105 hover:shadow-primary-xl"
        >
          <i className="ph-magic-wand inline-block align-middle text-[1.25em] mr-1"></i>
          Thử Ngay Với AI
        </button>
      </div>
    </section>
  );
};

export default HeroBanner;
